export default __webpack_public_path__ + "fill-none.asset.ddd419ca214418c6043a9b3899ba8bfa.svg";